import reducer from "./reducers";

import * as incidenciasOps from "./operations";
import * as incidenciasTypes from "./types";

export { incidenciasOps, incidenciasTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/incidencias/index.js